const numericColumn = ({ field, label, type = 'number', min = 0, max, step, unitKind, optional }) => ({
  header: label,
  field,
  type,
  min,
  ...(max !== undefined ? { max } : {}),
  ...(step !== undefined ? { step } : {}),
  ...(unitKind ? { unitKind } : {}),
  ...(optional ? { optional: true } : {}),
});

const STACKED_HIKE_FIELDS = new Set([
  'distance',
  'duration',
  'elevation_gain',
  'pack_weight',
  'perceived_effort',
]);

export function shouldUseStackedWorkoutSetLayout(columns = []) {
  if (!Array.isArray(columns)) return false;
  const fields = new Set(columns.map(column => column?.field).filter(Boolean));
  return [...STACKED_HIKE_FIELDS].every(field => fields.has(field));
}

export function getWorkoutSetColumns(exercise = {}) {
  if (Array.isArray(exercise.trackingFields) && exercise.trackingFields.length > 0) {
    return exercise.trackingFields.map(numericColumn);
  }

  const category = String(exercise.category || 'strength').toLowerCase();
  if (category === 'sport') {
    return [
      numericColumn({ field: 'calories', label: 'Calories' }),
      numericColumn({ field: 'duration', label: 'Duration', type: 'duration' }),
    ];
  }
  if (category === 'stretching') {
    return [numericColumn({ field: 'duration', label: 'Duration', type: 'duration' })];
  }
  if (category === 'static') {
    return exercise.externalLoadFactor === 0
      ? [numericColumn({ field: 'duration', label: 'Duration', type: 'duration' })]
      : [
          numericColumn({ field: 'weight', label: 'Weight' }),
          numericColumn({ field: 'duration', label: 'Duration', type: 'duration' }),
        ];
  }
  if (category === 'cardio') {
    return [
      numericColumn({ field: 'distance', label: 'Distance', unitKind: 'distance' }),
      numericColumn({ field: 'duration', label: 'Duration', type: 'duration' }),
    ];
  }
  return [
    numericColumn({ field: 'weight', label: 'Weight' }),
    numericColumn({ field: 'repetitions', label: 'Reps', step: 1 }),
  ];
}
